<div class="recreation-chooser mx-auto my-4">
    <a class="btn btn-sm btn-link ps-0 mb-2" routerLink="/apply"><i class="fa fa-arrow-left me-1"></i> Back to permit types</a>
    <h1 class="mt-0">Recreation permit</h1>
    <p class="text-muted">Which kind of site are you visiting? Road sites are charged per vehicle, boat-access sites per person.</p>

    <app-permit-type-chooser [choices]="choices"></app-permit-type-chooser>
</div>
